var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { createTransformer } from "mobx-utils";
import { parseTimeZone } from "./TimeZoneParser";
import { getTimeZoneFormatted } from "./TimeZoneFormatter";
import { getCurrentTime } from "./CurrentTimeHelper/CurrentTimeHelper";
import { formatTime } from "./CurrentTimeFormatter/CurrentTimeFormatter";
import { EventsManager } from "sb-js-extends";
export class Time {
    constructor() {
        this.currentTimeFormatted = createTransformer((timeFormat) => {
            return formatTime(this.currentTime, timeFormat);
        });
        this.eventsManager = new EventsManager();
        this.eventsManager.addEventListener("timezoneChanged", this, this.onTimeZoneChanged.bind(this), true);
    }
    static get getInstance() {
        return this.instance || (this.instance = new this());
    }
    init(provider) {
        if (typeof this.getServerDate === "undefined" && provider.getServerDate) {
            this.getServerDate = provider.getServerDate;
        }
        if (typeof this.currentTimeZone === "undefined" && provider.currentTimeZone) {
            this.currentTimeZone = parseTimeZone(provider.currentTimeZone);
        }
    }
    activate() {
        this.updateTime();
    }
    onTimeZoneChanged(timeZone) {
        this.currentTimeZone = parseTimeZone(timeZone);
    }
    get timeZoneFormatted() {
        return getTimeZoneFormatted(this.currentTimeZone);
    }
    updateTime() {
        this.currentTime = getCurrentTime(this.getServerDate(), this.currentTimeZone);
        this.timeOutInterval = setTimeout(this.updateTime.bind(this), 1000);
    }
    deactivate() {
        clearTimeout(this.timeOutInterval);
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], Time.prototype, "currentTimeZone", void 0);
__decorate([
    observable,
    __metadata("design:type", Date)
], Time.prototype, "currentTime", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Time.prototype, "onTimeZoneChanged", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Time.prototype, "timeZoneFormatted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Time.prototype, "updateTime", null);
//# sourceMappingURL=Time.js.map